module.exports = __webpack_public_path__ + "static/zuri-cvut-logo-a8ba1857e149731f39d85d06a4018b51.jpg";